import React, { useState, useEffect } from "react";
import { ResponsivePie } from "@nivo/pie";
import Bridge from "../../../../constants/Bridge";
import $ from "jquery";
import Strings from "../../../../constants/Strings";

const AllDemographicGraph = () => {
  const [reports, setReports] = useState([]);

  useEffect(() => {
    getReportData();
  }, []);

  const getReportData = () => {
    Bridge.radcliff_study
      .get_radcliff_demographics_chart_data()
      .then((result) => {
        if (result.status == "1") {
          let total = 0;
          for (let i = 0; i < result.data.length; i++) {
            total = total + result.data[i].count;
          }
          let newArra = [];
          for (let item of result.data) {
            let tempObj = {
              ...item,
              percentage: ((item.count / total) * 100).toFixed(2),
            };
            newArra.push(tempObj);
          }
          setReports(newArra);
        }
      })
      .catch((error) => {});
  };

  const portalPieData =
    reports &&
    reports.map((item, index) => {
      return {
        id: item.value + " (" + item.percentage + "%) ",
        label: item.value + " (" + item.percentage + "%) ",
        value: item.count,
        color: "#" + Math.floor(Math.random() * 0xffffff).toString(16),
      };
    });

  return (
    <div className="radcliff-all-demog-graph-wrapper">
      <hr />
      <br />
      <div className="row">
        <div
          className="col-lg-12 main-section add-user"
          style={{ paddingTop: 0 }}
        >
          <div
            className="wrapper clearfix position-relative"
            style={{
              paddingTop: 0,
              background: "#fff",
              transform: "scale(1)",
            }}
          >
            <div className="multisteps-form import-participant-block">
              <div className="bg-white" id="main-section">
                <div className="row bg-white" id="section-1">
                  <div
                    className="col-12 col-lg-12"
                    style={{ marginBottom: 40 }}
                  >
                    <div className="wizard-content-form ethnicity-report-1 bg-white diagnosis-report">
                      <div
                        className="wizard-form-field ml-0"
                        style={{ margin: "0px 0 14px 14px" }}
                      >
                        <br />
                        <div className="main-download-button">
                          <h1
                            className="pt-4 graph-heading"
                            style={{
                              fontSize: 27,
                              fontWeight: "600",
                              marginTop: -40,
                              marginBottom: 50,
                            }}
                          >
                            Demographics Distribution for Study Completed
                            Participants
                          </h1>
                        </div>
                        <div
                          style={{
                            width: "100%",
                          }}
                          className="graph-outer"
                        >
                          <ResponsivePie
                            data={portalPieData}
                            margin={{
                              top: $(window).width() < 600 ? 0 : 40,
                              right: 20,
                              bottom: 80,
                              left: $(window).width() < 600 ? 20 : -200,
                            }}
                            startAngle={-18}
                            innerRadius={0.5}
                            padAngle={0.7}
                            activeOuterRadiusOffset={8}
                            colors={{ scheme: "set3" }}
                            borderWidth={1}
                            borderColor={{
                              from: "color",
                              modifiers: [["darker", 0.2]],
                            }}
                            arcLinkLabelsSkipAngle={10}
                            arcLinkLabelsTextColor="#333333"
                            arcLinkLabelsThickness={2}
                            arcLinkLabelsColor={{ from: "color" }}
                            arcLabelsSkipAngle={10}
                            arcLabelsTextColor={{
                              from: "color",
                              modifiers: [["darker", 2]],
                            }}
                            defs={[
                              {
                                id: "dots",
                                type: "patternDots",
                                background: "inherit",
                                color: "rgba(255, 255, 255, 0.3)",
                                size: 4,
                                padding: 1,
                                stagger: true,
                              },
                              {
                                id: "lines",
                                type: "patternLines",
                                background: "inherit",
                                color: "rgba(255, 255, 255, 0.3)",
                                rotation: -45,
                                lineWidth: 6,
                                spacing: 10,
                              },
                            ]}
                            fill={[
                              {
                                match: {
                                  id: "ruby",
                                },
                                id: "dots",
                              },
                              {
                                match: {
                                  id: "c",
                                },
                                id: "dots",
                              },
                              {
                                match: {
                                  id: "go",
                                },
                                id: "dots",
                              },
                              {
                                match: {
                                  id: "python",
                                },
                                id: "dots",
                              },
                              {
                                match: {
                                  id: "scala",
                                },
                                id: "lines",
                              },
                              {
                                match: {
                                  id: "lisp",
                                },
                                id: "lines",
                              },
                              {
                                match: {
                                  id: "elixir",
                                },
                                id: "lines",
                              },
                              {
                                match: {
                                  id: "javascript",
                                },
                                id: "lines",
                              },
                            ]}
                            legends={[
                              {
                                anchor: "right",
                                direction: "column",
                                justify: false,
                                translateX: $(window).width() < 600 ? 20 : 20,
                                translateY: $(window).width() < 600 ? 240 : -30,
                                itemsSpacing: 0,
                                itemWidth: 280,
                                itemHeight: 33,
                                itemTextColor: "#000",
                                itemDirection: "left-to-right",
                                itemOpacity: 1,
                                symbolSize: 23,
                                symbolShape: "circle",
                                effects: [
                                  {
                                    on: "hover",
                                    style: {
                                      itemTextColor: "#000",
                                    },
                                  },
                                ],
                              },
                            ]}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllDemographicGraph;
